<template>
	<div class="page_box">
		<div class="msg_box clearfloat">
			<div class="arrow_box clearfloat">
				<span class="arrow_ywz">您的位置：</span>
				<div class="arrow">
					<span class="to" @click="xin.goUrl('/index')">首页</span>
					<span class="el-icon-arrow-right"></span>
					<span>个人中心</span>
					<span class="el-icon-arrow-right"></span>
					<span class="topc">{{personaliList | setName(this)}}</span>
				</div>
			</div>
			<div class="personal_menu">
				<div class="menu_to">个人中心</div>
				<div class="menu_box">
					<div class="menu_zi" :class="{'menu_zi_chon':className==itme.url}" @click="xin.goUrl(itme.url)" 
					 v-for="(itme,i) in personaliList" :key="i">{{itme.name}}</div>
				</div>
			</div>
			<div class="personal_box">
				 <router-view></router-view>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState,mapMutations} from 'vuex'
	export default{
		data(){
			return {
				personaliList:[
					{
						name:'编辑个人资料',
						url:'/personalCenter/personal',
						childs:[
							{
								name:'头像上传',
								url:'/personalCenter/head'
							}
						]
					},
					{
						name:'VIP申请',
						url:'/personalCenter/applyVip'
					},
					{
						name:'修改密码',
						url:'/personalCenter/changePassword'
					},
					{
						name:'积分信息',
						url:'/personalCenter/credits'
					},
					{
						name:'地址信息管理',
						url:'/personalCenter/site'
					},
					{
						name:'发票信息管理',
						url:'/personalCenter/invoice'
					},
					{
						name:'我的留言',
						url:'/personalCenter/leave'
					},
					{
						name:'我的订单',
						url:'/personalCenter/orderForm'
					},
					{
						name:'积分订单',
						url:'/personalCenter/miOrder'
					},
					{
						name:'我的发票',
						url:'/personalCenter/myInvoice'
					},
					{
						name:'浏览足迹',
						url:'/personalCenter/history'
					}
				]
			}
		},
		filters:{
			setName(data,_this){
				return _this.setName(data,_this);
			}
		},
		computed:{
			...mapState(['className'])
		},
		watch:{
			$route(to,frm){
				this.setclassName(to.path);
			}
		},
		methods:{
			...mapMutations(['setclassName']),
			setName(data){//路由回调
				let name;
				data.forEach((v,i)=>{
					if(v.url ==this.$route.path)
						name = v.name;
					else if(v.childs)
						name = this.setName(v.childs);
				})
				return name;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.page_box{
		box-sizing: border-box;
		border: 1px solid  #f6c6ce00;
		width: 100%;
		height: 100%;
		background: #F2F2F2;
		.msg_box{
			margin-bottom: 100px;
		}
		.personal_box{
			box-sizing: border-box;
			float: right;
			width: 860px;
			margin-left: 40px;
			background: #fff;
			padding: 40px;
		}
		.personal_menu{
			width: 300px;
			float: left;
			.menu_to{
				color: #fff;
				padding-left: 40px;
				line-height: 58px;
				background: var(--themeColor);
				height: 58px;
			}
			.menu_box{
				padding: 10px 40px ;
				background: #fff;
				font-size: 14px;
				.menu_zi{
					color: #666666;
					line-height: 40px;
					height: 40px;
					&:hover{
						cursor: pointer;
						color:#005599;
					}
				}
				.menu_zi_chon{
					font-weight: 500;
					color: #005599;
				}
			}
		}
		
	}
</style>

